import React, { useState, useRef } from 'react';

interface InfoBoxProps {
  item: object;
}

const InfoBox: React.FC<InfoBoxProps> = ({ children }) => {
  return <div className="info-box">{children}</div>;
};

export default InfoBox;
